// src/components/Avatar.js
import React from "react";
import multiavatar from "@multiavatar/multiavatar/esm";

export default function Avatar({ seed, size = 96, className = "" }) {
  // Generate the raw SVG string
  const svgCode = multiavatar(seed);

  return (
    <div
      className={`rounded-full overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      // dangerouslySetInnerHTML is fine here because the SVG is generated locally
      dangerouslySetInnerHTML={{ __html: svgCode }}
    />
  );
}
